import { useTranslation } from 'react-i18next';
import React from 'react';

import LINKS from 'shared/links';
import { LinkStyled, SubText, SubTextContainer, WeakText } from './SmsOptInPolicySubText.styles';

export function SmsOptInPolicySubText() {
  const { t } = useTranslation();

  return (
    <SubTextContainer>
      <SubText as="p">
        {t('account.smsOptIn.toOptOut')}
        <WeakText as="p">{t('account.smsOptIn.terms')}</WeakText>
        {t('account.smsOptIn.toView')}
        <LinkStyled to={LINKS.SMS_TERMS_AND_CONDITIONS}>
          {t('account.smsOptIn.termsAndConditions')}
        </LinkStyled>
        {t('account.smsOptIn.or')}
        <WeakText as="p">{t('account.smsOptIn.trust')}</WeakText>
        {t('account.smsOptIn.toView')}
        <LinkStyled to={LINKS.TRUST_PRIVACY_POLICY}>
          {t('account.smsOptIn.privacyPolicy')}
        </LinkStyled>
        {t('account.smsOptIn.period')}
      </SubText>
    </SubTextContainer>
  );
}

export default SmsOptInPolicySubText;
